(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/andra-chansen/andra-chansen-row-banner.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/andra-chansen/andra-chansen-row-banner.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$numbergames = svs.numbergames,
  openCampaignApi = _svs$numbergames.campaign.openCampaignApi,
  andraChansenBanners = _svs$numbergames.andra_chansen_banners;
svs.lotto.components.play.views.AndraChansenRowBanner = Marionette.View.extend({
  ballRowOptions: {},
  ballRowSize: 200,
  modelEvents: {
    'change:hasJoker change:numberOfValidBoards change:drawCount change:rowPriceMulti change:selectedDays': 'update'
  },
  template(_ref) {
    let banners = _ref.banners;
    return banners.render();
  },
  templateContext() {
    return {
      banners: this.banners
    };
  },
  initialize() {
    this.banners = andraChansenBanners.rowBanner(this.getBannerData());
  },
  update() {
    this.banners.update(this.getBannerData());
  },
  getBannerData() {
    const product = this.model.get('productId');
    const wager = this.model.toObject();
    const draws = svs.numbergames.game.draw.drawNumbers(this.model.get('selectedDays'));
    return _objectSpread({
      endDate: openCampaignApi.getCampaignEndDate(product, {
        draws
      }),
      isAndraChansenPeriodic: openCampaignApi.isPeriodicCampaign(product, {
        draws
      }),
      chances: openCampaignApi.calculateChances(product, {
        wager,
        draws
      }),
      isSubscription: this.model.get('isSubscription'),
      size: this.getOption('ballRowSize')
    }, this.getOption('ballRowOptions'));
  }
});

 })(window);